/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Harvest_CycleInputs */

const en_harvest_cycle = /** @type {(inputs: Harvest_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harvest Cycle`)
};

const es_harvest_cycle = /** @type {(inputs: Harvest_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciclo de cosecha`)
};

/**
* | output |
* | --- |
* | "Harvest Cycle" |
*
* @param {Harvest_CycleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const harvest_cycle = /** @type {((inputs?: Harvest_CycleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Harvest_CycleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_harvest_cycle(inputs)
	return es_harvest_cycle(inputs)
});